import React, { useState, useEffect } from "react";
import global from "../../global-variables";
import Header from "../layout/header";
import { Link } from "react-router-dom";
import $ from "jquery";
import WOW from "wowjs";
import Image from "react-image-webp";
import { Container, Row, Col } from "reactstrap";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Metatag from "../../hooks/Metatag";
import globalVariables from "../../global-variables";
import CountUp from "react-countup";
import axios from "axios";

export default function IITBCourses() {
  const [show, setShow] = useState(false);
  const [impactMetricsList, setImpactMetricsList] = useState(null);

  useEffect(() => {
    let _obj = new Object();
    _obj.imp_met_status = 1;

    axios
      .post(
        globalVariables.variables.strApiUrl +
          "/impactMetricsApi/getImpactMetricsList",
        _obj,
      )
      .then((response) => {
        setImpactMetricsList(response.data[0]);
      });
  }, []);

  useEffect(() => {
    $(window).on("scroll", function () {
      $(".navbar").offset().top > 10
        ? $(".fixed-top").removeClass("bg-header-home")
        : $(".fixed-top").removeClass("bg-header-home");
    });

    // initiate the wow effect
    new WOW.WOW({
      live: false,
    }).init();
  }, [impactMetricsList]);

  return (
    <>
      <Header></Header>

      <Metatag title="Education" description="Education" keywords="Education" />
      {/* Visual Panel */}
      <Container fluid className="bg-visual-inside px-0">
        <div className="visual-inside-big visual-container-inside">
          <Container>
            <Row className="g-md-0">
              <Col md={12}>
                <div className="py-md-4">
                  <div className="m-0 text-center py-xl-3 p-2 text-white">
                    <h1 className="fw-light text-white m-0 align-self-center wow fadeInUp">
                      Training and Education
                    </h1>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </Container>

      {/* Container */}
      <Container className="mt-5">
        <Row className="g-0">
          <Col md={12} lg={12}>
            <div className="borer rounded-4 _px-lg-5 p-4 h-100 text-center">
              <div className="pe-md-2 col-md-11 col-lg-10 list mx-auto">
                <p className="wow fadeInUp">
                  The Education and Training vertical at <b>GESH IITB</b> serves
                  as a hub for knowledge dissemination and skill-building in
                  Green Energy, Sustainability and Climate Services and
                  Solutions. It focuses on designing and delivering high-quality
                  training programs, workshops, and courses tailored to meet the
                  evolving needs of individuals and organizations.
                </p>
                <p className="wow fadeInUp">
                  Through collaborations with industry experts, faculty, and
                  researchers, GESH IITB ensures its offerings remain relevant
                  and impactful. By introducing innovative academic and
                  executive courses aligned with emerging trends, the vertical
                  aims to cultivate a deeper understanding of sustainability
                  principles and empower participants to drive meaningful
                  change.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      {impactMetricsList && impactMetricsList.length > 0 ? (
        <Container className="mb-5">
          <div className="">
            <Row className="row-cols-1 row-cols-md-2 row-cols-xl-5 g-4 justify-content-center">
              {impactMetricsList.map((item, index) => {
                return (
                  <Col key={item.imp_met_id}>
                    <div className="h-100 text-center bg-opacity-10 wow fadeInUp">
                      <div className="icon-100 bg-primary rounded-circle p-3 mb-3 overflow-hidden mx-auto">
                        <img
                          width="100"
                          height="100"
                          src={
                            global.variables.strApiUrl +
                            "/impact-metrics-icon/" +
                            item.imp_met_icon
                          }
                          alt={item.imp_met_heading}
                          className="img-fluid p-1 wow fadeInUp"
                        />
                      </div>
                      <h3 className="display-6 fw-bold text-primary mb-2">
                        <CountUp
                          start={0}
                          end={item.imp_met_number}
                          separator=","
                          suffix={"+"}
                          enableScrollSpy
                        />
                      </h3>
                      <p className="mb-0 text-muted">{item.imp_met_heading}</p>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </div>
        </Container>
      ) : null}

      <Container className="my-5">
        <div className="border rounded-4 p-lg-5 p-4">
          <Row className="row-cols-1 g-xl-5 g-4">
            <Col id="IITBCourses">
              <Row className="g-0">
                <Col md={8} lg={8} className="pe-lg-5 pe-md-4">
                  <h4 className="mb-3 wow fadeInUp">IITB Courses</h4>
                  <p className="wow fadeInUp">
                    IIT Bombay has been at the forefront of integrating
                    sustainability into its academic curriculum, ensuring that
                    students are equipped with the knowledge and skills to
                    address pressing environmental and societal challenges. You
                    can explore the{" "}
                    <a
                      href="https://docs.google.com/spreadsheets/d/10sHXBwt6Q2bL3BJLKcvFiW86nnLVB969vqd0VIixCO0/edit?gid=0#gid=0"
                      target="_blank"
                    >
                      list of sustainability courses offered at IIT Bombay
                    </a>{" "}
                    to learn more about the institute’s academic offerings in
                    this area.
                  </p>
                  <p className="wow fadeInUp">
                    As part of its <b>Living Lab Program</b>, GESH IITB is
                    introducing a new 6-credit course,{" "}
                    <b>SOM 694: Sustainability: Theory to Action</b> under the{" "}
                    <b>SJM School of Management (SJMSOM)</b>, offered as an
                    institute elective. The course will launch in the{" "}
                    <b>Spring Semester (January 2025)</b>
                  </p>
                  <p className="wow fadeInUp">
                    This course is uniquely designed to bring sustainability to
                    life through action-oriented learning. By integrating case
                    studies, hands-on activities, and expert-led masterclasses,
                    it equips students with practical skills in sustainability,
                    project management, and change leadership. This is more than
                    just a course—it’s an immersive journey to make
                    sustainability education engaging, practical, and impactful.
                  </p>
                </Col>
                <Col md={4} lg={4}>
                  <img
                    src={
                      global.variables.strDomainUrl +
                      "images/pic-education1.jpg"
                    }
                    className="img-fluid rounded-3 w-100 wow fadeInUp"
                  />
                </Col>
              </Row>
            </Col>
            <hr />
            <Col id="IndustryTrainingPrograms">
              <Row className="g-0">
                <Col
                  md={8}
                  lg={8}
                  className="ps-lg-5 pe-md-4 order-lg-2 mb-3 mb-lg-0"
                >
                  <h4 className="mb-3 wow fadeInUp">
                    Industry Training Programs
                  </h4>
                  <p className="wow fadeInUp">
                    GESH IITB offers specialized training programs and workshops
                    in green energy and sustainability, tailored to address the
                    specific needs of industries and organizations. Industries
                    can propose domains or modules for these sessions, ensuring
                    alignment with their operational goals and challenges.
                  </p>
                  <p className="wow fadeInUp">
                    By connecting industries with IIT Bombay's leading faculty,
                    researchers, and experts, GESH IITB delivers impactful
                    training in areas such as renewable energy technologies,
                    carbon management, sustainability frameworks, and the
                    circular economy. These initiatives equip organizations with
                    cutting-edge skills and knowledge, fostering the integration
                    of sustainability into corporate strategies and empowering
                    industries to lead the transition to a greener future.
                  </p>
                  <Link
                    to="/events"
                    state={{
                      eventTypeId:
                        globalVariables.variables.strTrainingProgramme_id,
                    }}
                    className="btn btn-primary rounded-pill px-4 py-2 wow fadeInUp"
                  >
                    Explore Learning Opportunities
                  </Link>
                </Col>
                <Col md={4} lg={4} className="order-lg-1">
                  <img
                    src={
                      global.variables.strDomainUrl +
                      "images/pic-training program.jpg"
                    }
                    className="img-fluid rounded-3 w-100 wow fadeInUp"
                  />
                </Col>
              </Row>
            </Col>
            <hr />
            {/* <Col id="EPGD">
              <Row className="g-0">
                <Col md={8} lg={8} className="pe-lg-5 pe-md-4">
                  <h4 className="mb-3 wow fadeInUp">ePGD</h4>
                  <p>More updates are coming soon!</p>
                </Col>
                <Col md={4} lg={4}>
                  <img src={global.variables.strDomainUrl + "images/pic-education3.jpg"} className="img-fluid rounded-3 w-100 wow fadeInUp" />
                </Col>
              </Row>
            </Col>
            <hr /> */}
            <Col id="Online_Courses">
              <Row className="g-0">
                <Col md={8} lg={8} className="ps-lg-5 pe-md-4 order-lg-2">
                  <h4 className="mb-3 wow fadeInUp">Online Courses </h4>
                  <p>
                    Professional Certificate in Sustainability Leadership and
                    Practice designed to build interdisciplinary competence
                    through the integration of sustainability science,
                    engineering principles, business strategy, policy
                    frameworks, and quantitative assessment tools. The programme
                    aims to equip professionals and future leaders with the
                    knowledge and skills required to address complex
                    sustainability challenges through systems thinking and
                    evidence-based decision-making.
                  </p>
                  <Link to="https://gesh.iitb.ac.in/event-details/sustainability-leadership-and-practice" target="_blank" rel="noopener noreferrer" className="btn btn-primary rounded-pill px-4 py-2 wow fadeInUp">
                    Explore Now
                  </Link>
                </Col>
                <Col md={4} lg={4} className="order-lg-1">
                  <img
                    src={
                      global.variables.strDomainUrl +
                      "images/professional-certificate.png"
                    }
                    className="img-fluid rounded-3 w-100 wow fadeInUp"
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </Container>

      {/* Breadcrumb */}
      <Breadcrumb className="breadcrumb-panel mt-auto">
        <Breadcrumb.Item href={globalVariables.variables.strDomainUrl}>
          Home
        </Breadcrumb.Item>
        <Breadcrumb.Item active>Training and Education</Breadcrumb.Item>
      </Breadcrumb>
    </>
  );
}
